module.exports = ".kan-login {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .kan-login .kan-login-form {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n  .kan-login .kan-login-form .kan-full-width {\n      width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/login/component.scss
// module id = ./src/modules/main/components/login/component.scss
// module chunks = main